import React, { Component } from 'react';
import { Pie, Column } from 'react-chartjs-2';
import Frame from './Frame';
import { Bar } from 'react-chartjs-2';
import moment, { relativeTimeRounding } from 'moment';
import FlipIcon from '../../src/components/css/dark/img/flip.svg';
import BarChartIcon from '../../src/components/css/dark/img/theme-images/bar-chart-icon.svg';
import RxBarChartIcon from '../../src/components/css/dark/img/theme-images/rx-bar-chart-icon.svg';
import BarChartIconInactive from '../../src/components/css/dark/img/theme-images/bar-chart-inactive.svg';
import listingIcon from '../../src/components/css/dark/img/theme-images/listing-icon.svg';
import listingIconActive from '../../src/components/css/dark/img/theme-images/listing-icon-active.svg';
import RxlistingIconActive from '../../src/components/css/dark/img/theme-images/rx-listing-icon-active.svg';
import loader from '../../src/components/css/dark/img/loader.gif';
import exportIcon from '../../src/components/css/dark/img/theme-images/export.svg';
import $ from 'jquery';
import Pagination from "react-js-pagination";
import ColorJson from '../../src/whitelabel.json';
if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
    import("./css/dark/rxhacker.css")
} else {
    import("./css/dark/main.css")
}

class MultiStackBar_List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            barChartIconInactive: false,
            chartData1: [],
            chartData2: [],
            columnData: [],
            options: {
                maintainAspectRatio: false,
            },
            IsDataLoaded: false,
            XlabelString: this.props.XlabelString,
            YlabelString: this.props.YlabelString,
            ColorCode: this.props.data.ColorCode,
            IFrameId: this.props._Index,
            LegendText1: '',
            LegendValue1: '',
            LegendText2: '',
            LegendValue2: '',
            LegendText3: '',
            LegendValue3: '',
            WidgetId: this.props.data.id,
            activePage: 1,
            negativeValues: false,
            noDataDisplay: '',
            sumOfLegendValue: ''
        };
    }
    handleFlip(event) {
        $(event.target).parent().next().toggleClass('flipped');
        $(event.target).toggleClass('active');
        $(event.target).parent().toggleClass('active');
    }
    ExportWidget = (event) => {
        try {
            let widgetTitle = '';
            var data = "";
            var tableData = [];
            try { widgetTitle = event.target.getAttribute('widget-title'); } catch (error) { }
            for (var i = 0; i < this.state.columnData.length; i++) {
                var rowData = [];
                for (var j = 0; j < this.state.columnData[i]["datasets"].length; j++) {
                    if ((widgetTitle == "Client Access Link Signups" && j == 0))
                        rowData.push(' ' + this.state.columnData[i]["datasets"][j]["data"].split(',').join(''));
                    else
                        rowData.push(this.state.columnData[i]["datasets"][j]["data"].split(',').join(''));
                }
                tableData.push(rowData.join(","));
            }
            data += tableData.join("\n");
            if (window.navigator.msSaveOrOpenBlob) {
                // IE11
                window.navigator.msSaveOrOpenBlob(new Blob([data]), $(event.target).attr('widget-title') + ".csv");
            } else {
                // Modern browsers
                const blob = new Blob([data], { type: "text/csv" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.id = 'download-link';
                link.download = $(event.target).attr('widget-title') + ".csv";
                link.href = url;
                document.body.appendChild(link);

                // Ensure DOM is ready, then click
                setTimeout(() => {
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url); // Clean up memory
                }, 0);
            }
        } catch (error) { }
    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "MultiBar_List") {
            //console.log("update Column", this.props)
            this.fetchData_locally();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "MultiBar_List") {
            // this.setState({ data2: { labels: ['Red', 'Blue', 'Yellow'], datasets: [{ data: [300, 50, 100] }] } })
            this.fetchData_locally();
        }
        window.Chart.defaults.global.defaultFontFamily = `'Fira Sans', sans-serif`;

        // default toggle 
        $('#WMetric1a1 .flip_icon').parent().next().toggleClass('flipped');
        $('#WMetric1a1 .flip_icon').toggleClass('active');
        $('#WMetric1a1 .flip_icon').parent().toggleClass('active');

        $('#DMetric1a1 .flip_icon').parent().next().toggleClass('flipped');
        $('#DMetric1a1 .flip_icon').toggleClass('active');
        $('#DMetric1a1 .flip_icon').parent().toggleClass('active');
    }
    Randomcolor_Random() {
        return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
    }
    Randomcolor(i) {

        //return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
        if (i % 10 == 0) {
            return '#39D890';
        } else if (i % 9 == 0) {
            return '#39D7D8';
        } else if (i % 8 == 0) {
            return '#FD775C';
        } else if (i % 7 == 0) {
            return '#80E166';
        } else if (i % 6 == 0) {
            return '#6AC7F1';
        } else if (i % 5 == 0) {
            return '#0282FB'
        } else if (i % 4 == 0) {
            return '#CB62FF'
        } else if (i % 3 == 0) {
            return '#7F84E8'
        } else if (i % 2 == 0) {
            return '#FCE048'
        } else {
            return '#FFBA10'
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    mobileMenu(event) {
        $('.flip-icons').hide();
        $('.export_icon').hide();
        $('.mobileExportLabel').hide();
        if ($(event.target).parents('.flip-section').children('.flip-icons').hasClass('active')) {
            $(event.target).parents('.flip-section').children('.flip-icons').show();
            $('.mobile_bar_icon').show();
            $('.mobileBarLabel').show();
            $(event.target).parents('.flip-section').children('.mobileExportLabel').show();
            $(event.target).parents('.flip-section').children('.onlyList').children('.export_icon').show();
            $('.mobile_list_icon').hide();
            $('.mobileListLabel').hide();
        } else {
            $(event.target).parents('.flip-section').children('.flip-icons').show();
            $('.mobile_list_icon').show();
            $('.mobileListLabel').show();
            $(event.target).parents('.flip-section').children('.mobileExportLabel').show();
            $(event.target).parents('.flip-section').children('.onlyList').children('.export_icon').show();
            $('.mobile_bar_icon').hide();
            $('.mobileBarLabel').hide();
        }
    }
    handleBarList(event) {
        if ($(window).width() < 850) {
            event.stopPropagation();
            $(event.target).parents('.custom-tooltip').siblings('.flip_icon').parent().next().toggleClass('flipped');
            $(event.target).parents('.custom-tooltip').siblings('.flip_icon').toggleClass('active');
            $(event.target).parents('.custom-tooltip').siblings('.flip_icon').parent().toggleClass('active');
            $(event.target).parents('.flip-section').children('.flip-icons').hide();
            $(event.target).parents('.flip-section').children('.mobileExportLabel').hide();
            $(event.target).parents('.flip-section').children('.onlyList').children('.export_icon').hide();
        }
    }
    fetchData_locally() {
        let data_available = '';
        this.setState({
            IsDataLoaded: false,
            noDataDisplay: 'Loading. Please wait.'
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'requestHeader': this.props.data.RequestJson1, 'X-Browser-Url': window.location.href },
            body: this.props.data.RequestJson
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    //--------------------------------Bar Chart
                    try {
                        this.setState({ LegendText1: apidata[0].legend[0].legendText, LegendValue1: apidata[0].legend[0].legendValue, LegendText2: apidata[0].legend[1].legendText, LegendValue2: apidata[0].legend[1].legendValue, LegendText3: apidata[0].legend[2].legendText, LegendValue3: apidata[0].legend[2].legendValue, columnData: apidata[0].listDataSet });
                        this.setState({ sumOfLegendValue: apidata[0].sumOfLegendValues[0].sumOfLegendValue });
                        this.setState({ activePage: 1 });
                        // data not available
                        data_available = apidata[0].columnDataSet1[0].data.length <= 1 && apidata[0].columnDataSet2[0].data.length <= 1 ? 'No Data Available' : '';

                    }
                    catch (error) {

                    }

                    let barHover;
                    let wlBgColor;
                    if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
                        barHover = ColorJson.ApplicationColor.Rxhacker_extra_color;
                        wlBgColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
                    } else {
                        barHover = '#FF8B6C';
                        wlBgColor = '#2A524B';
                    }

                    // check for negative values
                    apidata[0].columnDataSet1[0].data.every((item) => {
                        if (item.y < 0) {
                            this.setState({ negativeValues: true });
                            return false;
                        } else {
                            return true;
                        }
                    });

                    var DistData = {
                        label: apidata[0].columnDataSet1[0].toplabel,
                        data: apidata[0].columnDataSet1[0].data,
                        backgroundColor: wlBgColor,
                        borderColor: wlBgColor,
                        stack: '1',
                        BorderRadius: this.state.BorderRadius,
                        hoverBackgroundColor: "#000"
                    };

                    var SubDistData = {
                        label: apidata[0].columnDataSet2[0].toplabel,
                        data: apidata[0].columnDataSet2[0].data,
                        backgroundColor: this.state.ColorCode,
                        borderColor: this.state.ColorCode,
                        stack: '1',
                        hoverBackgroundColor: barHover,
                        BorderRadius: this.state.BorderRadius
                    };
                    var BonusData = {
                        label: apidata[0].columnDataSet4[0].toplabel,
                        data: apidata[0].columnDataSet4[0].data,
                        backgroundColor: barHover,
                        borderColor: barHover,
                        stack: '1',
                        hoverBackgroundColor: "#44b672",
                        BorderRadius: this.state.BorderRadius
                    };
                    var leftPosition;
                    var cOverride = this.state.LegendText2;
                    this.setState({
                        ...this.state,
                        noDataDisplay: data_available,
                        IsDataLoaded: true,
                        chartData1: [
                            {
                                labels: apidata[0].columnDataSet1[0].labels,
                                datasets: [DistData, SubDistData, BonusData]
                            }
                        ],
                        options: {
                            layout: {
                                padding: {
                                    top: 70
                                }
                            },
                            onHover: function(event) {
                                leftPosition = event.layerX;
                                if (leftPosition == undefined) {
                                    leftPosition = parseInt(event.touches[0].pageX);
                                }                                
                            },

                            tooltips: {
                                
                                // Disable the on-canvas tooltip
                                enabled: false,

                                custom: function (tooltipModel) {                                    
                                    // Tooltip Element
                                    var tooltipEl = document.getElementById('chartjs-tooltip');
                                    // Create element on first render
                                    if (!tooltipEl) {
                                        tooltipEl = document.createElement('div');
                                        tooltipEl.id = 'chartjs-tooltip';
                                        tooltipEl.innerHTML = '<table style="background: #fff; margin-left: calc(-50% - 6px); position: relative; z-index: 99999; font-weight: 600; border: 2px solid #B6ACA2; border-radius: 6px; padding: 10px; line-height: 28px; font-family: Apercu-Regular; color: #17332e; white-space: nowrap; font-size: 17px; text-align: center; display: block;"></table>';
                                        document.body.appendChild(tooltipEl);
                                    }

                                    // Hide if no tooltip
                                    if (tooltipModel.opacity === 0) {
                                        tooltipEl.style.opacity = 0;
                                        tooltipEl.style.display = 'none';
                                        return;
                                    }

                                    // Set caret Position
                                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                                    if (tooltipModel.yAlign) {
                                        tooltipEl.classList.add(tooltipModel.yAlign);
                                    } else {
                                        tooltipEl.classList.add('no-transform');
                                    }

                                    function getBody(bodyItem) {
                                        return bodyItem.lines;
                                    }

                                    // `this` will be the overall tooltip
                                    var position = this._chart.canvas.getBoundingClientRect();


                                    // Set Text
                                    if (tooltipModel.body) {
                                        var titleLines = tooltipModel.title || [];
                                        var bodyLines = tooltipModel.body.map(getBody);

                                        var innerHtml = '<thead>';

                                        titleLines.forEach(function (title) {
                                            innerHtml += '<tr><th style="font-size: 15px; line-height: 18px; padding: 0px;display: block; font-weight: normal;">' + title + '</th></tr>';
                                        });
                                        innerHtml += '</thead><tbody>';

                                        bodyLines.forEach(function (body, i) {
                                            var colors = tooltipModel.labelColors[i];

                                            if (cOverride == "Override") {
                                                if (leftPosition > (position.width - 50)) {
                                                    var span = '<span style="position: absolute; bottom: -7px; right: 2px; margin-left: -6px; width: 0; height: 0; border-left: 6px solid transparent; border-right: 6px solid transparent; border-top: 6px solid #B6ACA2;"></span>';
                                                } else {
                                                    var span = '<span style="position: absolute; bottom: -7px; left: 50%; margin-left: -6px; width: 0; height: 0; border-left: 6px solid transparent; border-right: 6px solid transparent; border-top: 6px solid #B6ACA2;"></span>';
                                                }
                                            } else {
                                                var span = '<span style="position: absolute; bottom: -7px; left: 50%; margin-left: -6px; width: 0; height: 0; border-left: 6px solid transparent; border-right: 6px solid transparent; border-top: 6px solid #B6ACA2;"></span>';
                                            }

                                            innerHtml += '<tr><td>' + span + body + '</td></tr>';
                                        });
                                        innerHtml += '</tbody>';

                                        var tableRoot = tooltipEl.querySelector('table');
                                        tableRoot.innerHTML = innerHtml;
                                    }

                                    // Display, position, and set styles for font
                                    tooltipEl.style.opacity = 1;
                                    tooltipEl.style.display = 'block';
                                    if ($(window).width() < 980) {
                                        setTimeout(() => {
                                            tooltipEl.style.display = 'none';
                                        }, 3000)
                                    }
                                    tooltipEl.style.position = 'absolute';
                                    if (cOverride == "Override") {
                                        if (leftPosition > (position.width - 50)) {
                                            tooltipEl.style.left = parseInt(position.left) + window.pageXOffset + tooltipModel.caretX + -56 + 'px';
                                        } else {
                                            tooltipEl.style.left = parseInt(position.left) + window.pageXOffset + tooltipModel.caretX + 'px';
                                        }
                                    } else {
                                        tooltipEl.style.left = parseInt(position.left) + window.pageXOffset + tooltipModel.caretX + 'px';
                                    }
                                    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + -85 + 'px';
                                    tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                                    tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                                    tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                                    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                                    tooltipEl.style.pointerEvents = 'none';
                                }
                            },
                            maintainAspectRatio: false,
                            responsive: true,
                            legend: {
                                labels: {
                                    fontColor: '#8ba6c1)'
                                },
                                display: false
                            },
                            scales: {
                                yAxes: [{
                                    ticks: this.state.negativeValues ? {
                                        fontColor: "#B6ACA2",
                                        fontSize: 14,
                                        beginAtZero: true,
                                        min: -2,
                                        max: 4
                                    } : {
                                        fontColor: "#B6ACA2",
                                        fontSize: 14,
                                        beginAtZero: true
                                    },
                                    gridLines: {
                                        lineWidth: 0,
                                        display: false,
                                        drawBorder: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: this.props.data.YlabelString,
                                        fontFamily: 'Apercu-Regular',
                                        fontColor: '#B6ACA2',
                                        fontSize: 14
                                    }
                                }],
                                xAxes: [{
                                    offset: true,
                                    barThickness: 15,
                                    maxBarThickness: 15,
                                    minBarLength: 3,
                                    ticks: {
                                        display: false,
                                        autoSkip: true,
                                        maxTicksLimit: 5,
                                        fontColor: "#B6ACA2",
                                        fontSize: 14
                                    },
                                    gridLines: {
                                        lineWidth: 0,
                                        display: false,
                                        drawBorder: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: this.props.data.XlabelString,
                                        fontFamily: 'Apercu-Regular',
                                        fontColor: '#B6ACA2',
                                        fontSize: 14
                                    }
                                }]
                            }

                        }
                    });

                    //---------------------------------List Chart
                    try {

                        //this.setState({
                        // ... this.state ,columnData: apidata[0].listDataSet
                        //});
                    }
                    catch (error) { }

                }
                catch (error) {
                }
            });
    }
    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber });
    }
    handleBar(event) {
        $(event.target).parent().parent().next().toggleClass('flipped');
        $(event.target).parent().next().toggleClass('active');
        $(event.target).parent().parent().toggleClass('active');
    }
    handleList(event) {
        $(event.target).parent().parent().next().toggleClass('flipped');
        $(event.target).parent().prev().toggleClass('active');
        $(event.target).parent().parent().toggleClass('active');
    }
    titleHover = e => {
        if (this.isEllipsisActive(e.target)) {
            e.target.parentElement.classList.add("hover-on");
        }
    }
    isEllipsisActive = (element) => {
        return element.offsetWidth < element.scrollWidth;
    }

    render() {
        var tooltipColor1 = "#2A524B";
        const tooltipColor2 = this.props.data.ColorCode;
        var tooltipColor3 = "#FF8463";
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            tooltipColor1 = ColorJson.ApplicationColor.Rxhacker_secondary_color;
            tooltipColor3 = ColorJson.ApplicationColor.Rxhacker_extra_color;
        } else {
            tooltipColor1 = "#2a524b";
            tooltipColor3 = "#FF8463";
        }
        let a1 = this.state.LegendText1;
        let a2 = this.state.LegendText2;
        const userlistobj = JSON.parse(JSON.stringify(this.state.columnData));
        userlistobj.splice(0, 1);
        let paging = 0;
        paging = userlistobj.length % 6 != 0 ? userlistobj.length + 6 - userlistobj.length % 6 : userlistobj.length;

        return (
            <div className="bar">
                {this.state.IsDataLoaded ? '' : (<div className="loader-section"><div className="theme-loader"></div></div>)}
                <div className="flip-section">
                    <div className="widget-head mobile-position">
                        <h3>
                            <a>
                                {
                                    this.props.data.title != "Client Access Link Signups" && this.props.data.title != "New vs Repeat Transactions" ?
                                        <span>$ {this.state.sumOfLegendValue + " "}</span> :
                                        <span>{this.state.sumOfLegendValue + " "}</span>
                                }
                                <span className="transition-title" data-title={this.props.data.title}><label onMouseOver={this.titleHover}>{this.props.data.title}</label><p>{this.props.data.Subtitle}</p></span>
                            </a>
                        </h3>
                    </div>
                    <a href="javascript:void('0')" widget-id={this.props.data.id} widget-title={this.props.data.title} onClick={this.ExportWidget} className='onlyList custom-tooltip' id={this.props.data.title}><img className="export_icon" widget-title={this.props.data.title} widget-id={this.props.data.id} src={exportIcon} alt="Export Icon" /><span className="hover-tooltip down-report">Download report</span></a>
                    <label className="mobileExportLabel" widget-title={this.props.data.title} widget-id={this.props.data.id} onClick={this.ExportWidget}>Export</label>
                    {/*<div className="transitions">
                        <div className="left"><span className="rectangle" style={{ background: tooltipColor }}>&nbsp;</span><span className="bold">{this.state.LegendValue}</span></div>
                        <div className="right">
                            <span>{this.state.LegendText}</span>
                        </div>
                    </div>*/}
                    <a className="mobileListIcon" href="javascript:void('0')" onClick={this.mobileMenu}>
                        <span className="dot">;&nbsp</span>
                        <span className="dot">;&nbsp</span>
                        <span className="dot">;&nbsp</span>
                    </a>
                    <div className="flip-icons">
                        <a href="javascript:void('0')" className="custom-tooltip">
                            <img className="bar_chart_icon" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxBarChartIcon : BarChartIcon} alt="barcharticon" />
                            <img className="mobile_bar_icon" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxBarChartIcon : BarChartIcon} alt="barcharticon" />
                            <label onClick={this.handleBarList} className="mobileBarLabel">Bar</label>
                            <img className="bar_chart_icon inactive" onClick={this.handleBar} src={BarChartIconInactive} alt="barcharticoninactive" />
                            <span className="hover-tooltip bar">Bar</span></a>
                        <a href="javascript:void('0')" onClick={this.handleFlip} className="flip_icon">Flip</a>
                        <a href="javascript:void('0')" className="custom-tooltip">
                            <img className="listing-icon" onClick={this.handleList} src={listingIcon} alt="listingicon" />
                            <img onClick={this.handleBarList} className="listing-icon activeicon" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxlistingIconActive : listingIconActive} alt="listcharticonactive" />
                            <img onClick={this.handleBarList} className="mobile_list_icon" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxlistingIconActive : listingIconActive} alt="listcharticonactive" />
                            <span className="hover-tooltip list">List</span>
                            <label className="mobileListLabel" onClick={this.handleBarList}>List</label>
                        </a>
                    </div>
                    <div className="flip-bg multibar" id={this.state.IFrameId + "_flip_bg_frame"}>
                        <div className="front">
                            <div className="first">
                                {
                                    this.state.chartData1.length > 0 && this.state.chartData1[0].labels.length > 0 && this.state.chartData1 != null ?
                                        <div>
                                            <div className="transitions">
                                                <div className="same-transitions">
                                                    <div className="left"><span className="rectangle" style={{ background: tooltipColor1 }}>&nbsp;</span><span className="bold">{this.state.LegendValue1}</span></div>
                                                    <div className="right">
                                                        <span>{this.state.LegendText1}</span>
                                                    </div>
                                                </div>
                                                <div className="same-transitions">
                                                    <div className="left"><span className="rectangle" style={{ background: tooltipColor2 }}>&nbsp;</span><span className="bold">{this.state.LegendValue2}</span></div>
                                                    <div className="right">
                                                        <span>{this.state.LegendText2}</span>
                                                    </div>
                                                </div>
                                                <div className="same-transitions">
                                                    <div className="left"><span className="rectangle" style={{ background: tooltipColor3 }}>&nbsp;</span><span className="bold">{this.state.LegendValue3}</span></div>
                                                    <div className="right">
                                                        <span>{this.state.LegendText3}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="BarChart" scrolling="no" key="barchart_">
                                                <div className="myBarChart">
                                                    {
                                                        this.state.chartData1 != null ? this.state.chartData1.map((item, index) => {
                                                            return <Bar data={item} options={this.state.options} key={index} />
                                                        }) : null
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        : <span className="data-not-found">{this.state.noDataDisplay}</span>
                                }
                            </div>
                        </div>
                        <div className="back">
                            <div className="second">
                                <div className="widget-iframe">
                                    <div className="myListChart myColumnChart col-lg-12" id={this.props.data.id}>
                                        {
                                            this.state.columnData != null ?
                                                <div>
                                                    <div className="mobile-scrolling-all tool-section list-data">
                                                        {
                                                            this.state.columnData.length > 1 ?
                                                                <div>

                                                                    {

                                                                        this.state.columnData != null ? this.state.columnData[0] ?
                                                                            <div className="tableheader" key={"TableHeader0"}>
                                                                                {this.state.columnData[0]["datasets"].map((e2, i2) => {
                                                                                    return (
                                                                                        <div key={'xyz' + i2}>{e2.data}</div>
                                                                                    )
                                                                                })}
                                                                            </div> : null : null
                                                                    }

                                                                    <div className="mainList">
                                                                        {


                                                                            (userlistobj.length > 6 ? userlistobj.splice((this.state.activePage - 1) * 6, 6) : userlistobj).map((obj, index) => {
                                                                                let headingtxt = this.state.columnData[0]["datasets"];
                                                                                return <div className="tablebody" key={"tablebody" + index}>
                                                                                    {obj["datasets"].map((e2, i2) => {
                                                                                        return (
                                                                                            <div key={'xyz' + i2}>{e2.data}</div>
                                                                                        )
                                                                                    })}
                                                                                </div>

                                                                            })
                                                                        }
                                                                    </div>
                                                                    <Pagination
                                                                        activePage={this.state.activePage}
                                                                        itemsCountPerPage={6}
                                                                        totalItemsCount={paging}
                                                                        pageRangeDisplayed={5}
                                                                        onChange={this.handlePageChange.bind(this)}
                                                                    />

                                                                </div>
                                                                : <span className="data-not-found">{this.state.noDataDisplay}</span>
                                                        }
                                                    </div></div> : null

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default MultiStackBar_List;
